var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwarmLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.3 100.3",
    style: {
      enableBackground: "new 0 0 100.3 100.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#242424;}\n\t.st1{fill:#DB7200;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Swarm Logo 1 \u25CB_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50.2,
    cy: 50.2,
    r: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48,68.9 48,54 34.6,46.5 21.3,54 21.3,68.9 34.7,76.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.3,54 52.3,68.9 65.7,76.4 79,68.9 79,54 65.7,46.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "56.7,34 54.7,32.8 54.7,30.6 54.7,23.2 50.1,20.4 36.7,27.9 36.7,42.8 50.1,50.3 63.4,42.8  63.4,37.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.8,22.6 65.7,18.6 58.6,22.6 58.6,22.6 58.6,30.6 65.7,34.5 65.7,34.6 72.8,30.6  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwarmLogo2);
export default __webpack_public_path__ + "static/media/swarm-logo-2.9bcf9cfe372b575851bb8e238320c6ae.svg";
export { ForwardRef as ReactComponent };